import { Controller } from '@hotwired/stimulus';

// Adds `is-active` the first time the element scrolls into view, then stops
// observing; a `selector` value targets matching descendants instead.
// Activation removes → reflows → re-adds the class so gated CSS animations
// restart from their first frame even if already marked active.
export default class extends Controller {
  static values = {
    selector: { type: String, default: '' },
    threshold: { type: Number, default: 0.35 },
  };

  connect() {
    const enter = this.thresholdValue;
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= enter) this.__activate();
        });
      },
      { threshold: enter > 0 ? [0, enter] : [0] },
    );
    this.observer.observe(this.element);
  }

  disconnect() {
    this.observer?.disconnect();
    this.observer = null;
  }

  __activate() {
    const targets = this.selectorValue ? [...this.element.querySelectorAll(this.selectorValue)] : [this.element];
    targets.forEach((el) => el.classList.remove('is-active'));
    targets.forEach((el) => void el.offsetWidth); // reflow → restart animations
    targets.forEach((el) => el.classList.add('is-active'));
    this.observer?.disconnect();
    this.observer = null;
  }
}
